export default {
  Packages: {
    Package: 'پکیج',
    History: {
      Title: 'وضعیت پکیج ها',
      TableTitle: 'سابقه خرید',
      NotFound: 'شما هیچ سابقه خرید پکیجی ندارید.',
    },
    BuyPage: {
      Title: 'خرید پکیج جدید',
      Cost: 'شارژ',
      Discount: 'تخفیف',
      BuyCost: 'مبلغ پرداخت',
      Buy: 'پرداخت',
    },
    Search: {
      Customer: 'جستجو بر اساس مشتری',
      Package: 'جستجو بر اساس پکیج',
    },
    Name: 'نام بسته',
    Cost: 'شارژ اولیه',
    DailyCost: 'هزینه روزانه',
    RemainderCharge: 'شارژ باقیمانده',
    Days: 'روز',
    BuyCost: 'مبلغ خرید',
    Buy: 'خرید پکیج جدید',
    NoDiscount: 'بدون تخفیف',
    Description: 'توضیحات',
  },
}
